function fovInit(container) {
  function displayError(msg) {
    var err = formGroup.querySelector(".usa-error-message");

    if (!err) {
      err = document.createElement("span");
      err.setAttribute("class", "usa-error-message");
    }

    err.innerText = msg;

    formGroup.setAttribute("class", containerClass + " usa-form-group--error");
    formGroup.insertBefore(err, input);

    result.setAttribute(
      "class",
      resultClass + " sos-calculator__result--pending"
    );
    result.innerText = "--";
  }

  function clearError() {
    var err;

    formGroup.setAttribute("class", containerClass);
    err = formGroup.querySelector(".usa-error-message");
    if (err) formGroup.removeChild(err);
  }

  function validate(s) {
    var numRegEx = /^\d+(?:\.\d+)?$/g;
    return numRegEx.test(s);
  }

  function onInput() {
    var d, fov;

    if (input.value === "") {
      clearError();
      result.innerText = "--";
      return;
    }

    if (!validate(input.value)) {
      displayError("Distance must be a valid number");
      return;
    }

    d = Number.parseFloat(input.value);

    if (d < 36.55) {
      result.setAttribute(
        "class",
        resultClass + " sos-calculator__result--pending"
      );
      result.innerText = "--";
      return;
    }

    fov = (2 * Math.asin(H / (2 * d)) * 180) / Math.PI;

    clearError();
    result.setAttribute("class", resultClass);
    result.innerText = fov.toFixed(2) + "°";
  }

  // Projected image height in inches based on the "classic" SOS field of view.
  var H = 73.1;

  var input = container.querySelector(".sos-fov__input"),
    result = container.querySelector(".sos-fov__result"),
    formGroup = input.parentElement,
    containerClass = formGroup.getAttribute("class"),
    resultClass = result.getAttribute("class");

  input.addEventListener("input", onInput);
  result.setAttribute(
    "class",
    resultClass + " sos-calculator__result--pending"
  );

  container.removeAttribute("x-cloak");
}

function init() {
  var forms = document.querySelectorAll(".sos-fov"),
    i,
    n;

  for (i = 0, n = forms.length; i < n; i++) {
    fovInit(forms[i]);
  }
}

if (typeof document.querySelectorAll === "function") {
  window.addEventListener("load", init);
}
